<template>
  <div
    :data-testid="`my-calendar.meeting-request-card.card.${meetingRequestInfo.id}`"
    :class="['request-card-layout', !meetingRequestInfo.is_conflicted ? 'available' : 'conflict', { processing: isProcessing }]"
  >
    <div v-if="isProcessing" class="card-loading-overlay">
      <ArrowSmall class="card-loading-icon" />
    </div>
    <div :data-testid="`my-calendar.meeting-request-card.open-detail-btn.${meetingRequestInfo.id}`" class="request-card-content" @click="openMeetingCard">
        <div class="flex justify-between items-center text-xs ">
          <span :data-testid="`my-calendar.meeting-request-card.patient-name-text.${meetingRequestInfo.id}`" style="color: #666666;"> {{ meetingRequestInfo.patient_firstname + ' ' + meetingRequestInfo.patient_lastname }} </span>
          <div v-if="!meetingRequestInfo.is_conflicted" :data-testid="`my-calendar.meeting-request-card.available-status-chip.${meetingRequestInfo.id}`" class="status-chip available"> Available </div>
          <div v-if="meetingRequestInfo.is_conflicted" :data-testid="`my-calendar.meeting-request-card.conflict-status-chip.${meetingRequestInfo.id}`" class="status-chip conflict"> Conflict </div>

        </div>
        <div class="flex justify-center">
          <span :data-testid="`my-calendar.meeting-request-card.time-text.${meetingRequestInfo.id}`" :class="{ 'text-[#E3B946]': meetingRequestInfo.is_conflicted }">{{ formatedDate(meetingRequestInfo.requested_start_time,meetingRequestInfo.requested_end_time) }}</span>
        </div>
        <div v-if="action" :data-testid="`my-calendar.meeting-request-card.action-result-text.${meetingRequestInfo.id}`" class="action-bar">
          <div v-if="action === 'decline'" class="flex items-center gap-2">
            <img class="inline-block " src="@/assets/my-calendar/meeting-request/red-cross.svg" alt="decline" />
            <span style="color: #D10000;">Appointment Declined</span>
          </div>
          <div v-if="action === 'accept'" class="flex items-center gap-2">
            <img class="inline-block " src="@/assets/my-calendar/meeting-request/green-checked.svg" alt="confirm" />
            <span style="color: #0A6629;">Appointment Accepted</span>
          </div>

        </div>
        <div v-else class="action-bar">
          <div :data-testid="`my-calendar.meeting-request-card.decline-btn.${meetingRequestInfo.id}`" class="action-btn decline" @click.stop="handleAciton('decline')">
            <img class="inline-block " src="@/assets/my-calendar/meeting-request/red-cross.svg" alt="decline" />
            Decline
          </div>
          <div :data-testid="`my-calendar.meeting-request-card.reschedule-btn.${meetingRequestInfo.id}`" class="action-btn reschedule" @click.stop="handleAciton('reschedule')">
            <img class="inline-block" src="@/assets/my-calendar/meeting-request/yellow-question.svg" alt="reschedule" />
            Reschedule
          </div>
          <div :data-testid="`my-calendar.meeting-request-card.accept-btn.${meetingRequestInfo.id}`" class="action-btn accept" @click.stop="handleAciton('accept')">
            <img class="inline-block" src="@/assets/my-calendar/meeting-request/green-checked.svg" alt="confirm" />
            Accept
          </div>
        </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import ArrowSmall from '@/NewLibrary/Loading/ArrowSmall.vue'
import moment from 'moment-timezone'
import { useStore } from 'vuex'
  
const store = useStore()
const emit = defineEmits(['remove','open-meeting-card','open-schedule-dialog','action-start','action-success']) 

const { meetingRequestInfo, actionState } = defineProps({
  meetingRequestInfo: Object,
  actionState: {
    type: Object,
    default: null
  }
});

const calendarTimezone = computed(() => store.getters['calendar/calendarTimezone'])
const isProcessing = computed(() => actionState?.phase === 'loading')
const action = computed(() => actionState?.phase === 'success' ? actionState.action : '')
  
const handleAciton = async (val) => {
  // console.log(meetingRequestInfo,'meetingRequestInfo')
  // return
  // action.value = val
  if (isProcessing.value) {
    return
  }

  const firstNameInitial = meetingRequestInfo.patient_firstname ? `${meetingRequestInfo.patient_firstname.charAt(0)}.` : '';
  let meetingRequestTitle = meetingRequestInfo.patient_lastname ? `${firstNameInitial} ${meetingRequestInfo.patient_lastname}`.trim() : '';

  const eventInput = {
    event_title: meetingRequestTitle,
    start_time: meetingRequestInfo.requested_start_time,
    end_time: meetingRequestInfo.requested_end_time,
    creator_calendar_id: store.state.calendar.creatorCalendarId,
    practice_id: meetingRequestInfo.clinic.clinic_id,
    participants:[
      {
        participant_calendar_id: meetingRequestInfo.patient_calendar_id,
        role: 'patient'
      },
      {
        participant_calendar_id: meetingRequestInfo.provider_calendar_id,
        role: 'provider'
      }
    ]
  }

  if(val === 'reschedule') {
    emit('open-schedule-dialog',meetingRequestInfo)
    return
  }

  emit('action-start', val)

  if(val === 'accept') {
    await store.dispatch('calendar/updateMeetingRequest', { 
      id: meetingRequestInfo.uuid, 
      status: 'accepted',
      event_input: eventInput
    })
    await store.dispatch('calendar/fetchMeetingRequests');
    const userInfo = store.state.login.userInfo;
    const isClinic150105 = userInfo?.clinic_id === 150105;
    const selectedClinicianCalendarIds = store.getters['calendar/selectedClinicianCalendarIds'] || []
    const calendarIds = isClinic150105 
      ? selectedClinicianCalendarIds
      : [store.state.calendar.creatorCalendarId];

    if (isClinic150105 && calendarIds.length === 0) {
      store.commit('calendar/SET_RAW_EVENT_LIST', [])
      return
    }
    
    store.commit('calendar/SET_CALENDAR_LOADING', true);
    await store.dispatch('calendar/fetchEvents', {
      calendar_ids: calendarIds,
      start_time: moment.utc('1970-01-01').startOf('day').toISOString(),
      end_time: moment().add(2, 'years').endOf('day').toISOString()
    })
    store.commit('calendar/SET_CALENDAR_LOADING', false);
  }else if(val === 'decline') {
    await store.dispatch('calendar/updateMeetingRequest', { 
      id: meetingRequestInfo.uuid, 
      status: 'rejected' ,
      cancellation_reason: 'Provider Declined - Test'
    })
    await store.dispatch('calendar/fetchMeetingRequests');
  }

  emit('action-success', val)

  setTimeout(() => {
    emit('remove')
  }, 800)

  }
  
  const formatedDate = (startStr,endStr) => {
    const startFmt = `${moment.utc(startStr).tz(calendarTimezone.value).format('MMM D, YYYY')} ${moment.utc(startStr).tz(calendarTimezone.value).format('h:mmA')}`
    const endFmt = moment.utc(endStr).tz(calendarTimezone.value).format('h:mmA')

    return `${startFmt} - ${endFmt}`;
  };

const openMeetingCard = () => {
  if (isProcessing.value) {
    return
  }

  emit('open-meeting-card')
}

</script>

<style scoped>
.request-card-layout {
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  border-radius: 5px;
  box-shadow: 0px 1px 10px 0px #4A4A4A14;
  padding: 12px;
  gap: 12px;
  font-size: 14px;
  border: 1.3px solid transparent; 
  cursor: pointer;
  position: relative;
}
.request-card-layout.processing {
  cursor: default;
}
.request-card-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.card-loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.72);
  border-radius: 5px;
  z-index: 2;
}
.card-loading-icon {
  width: 24px;
  height: 24px;
  transform-origin: center;
  animation: rotate 1.6s linear infinite;
}
.request-card-layout.available:hover {
  border: 1.3px solid #25B8C2;
  background: #25B8C208;
}
.request-card-layout.available.processing:hover {
  border: 1.3px solid transparent;
  background: #FFFFFF;
}
.request-card-layout.conflict:hover {
  border: 1.3px solid #E0961E;
  background: #E0961E08;
}
.request-card-layout.conflict.processing:hover {
  border: 1.3px solid transparent;
  background: #FFFFFF;
}
.action-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #F9FBFD;
  color: #666666;
  padding: 0 1px;
  border-radius: 4px;
  min-height: 24px;
}
.action-btn {
  display:flex ;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  padding-left: 4px;
  padding-right: 8px;
  gap:6px;

}
.action-btn:hover {
  text-decoration: underline;
}
.action-btn.decline:hover {
  color: #D10000;
}
.action-btn.reschedule:hover {
  color: #E0961E;
}
.action-btn.accept:hover {
  color: #0A6629;
}
.status-chip{
  padding: 2px 8px;
  border-radius: 20px;
}
.status-chip.available{
  background: #EBFFF8;
  color: #25B8C2;
}
.status-chip.conflict{
  background: #F7EECE;
  color: #E3B946;
}
</style>
